const START_YEAR = 1999;
const END_YEAR = 2030;
const yearsArr = Array.from(
    { length: END_YEAR - START_YEAR + 1 },
    (_, i) => START_YEAR + i
);

export const years = yearsArr.map(year => ({
    text: year.toString() + "年",
    value: year
}));

const START_MONTH = 1;
const END_MONTH = 12;
const monthsArr = Array.from(
    { length: END_MONTH - START_MONTH + 1 },
    (_, i) => START_MONTH + i
);

export const months = monthsArr.map(month => ({
    text: month.toString() + "月",
    value: month.toString().length === 1 ? "0" + month.toString() : month.toString()
}));


